
namespace TabAurous.OMS {

    @Serenity.Decorators.registerClass()
    export class ServicesMasterDialog extends Serenity.EntityDialog<ServicesMasterRow, any> {
        protected getFormKey() { return ServicesMasterForm.formKey; }
        protected getIdProperty() { return ServicesMasterRow.idProperty; }
        protected getLocalTextPrefix() { return ServicesMasterRow.localTextPrefix; }
        protected getNameProperty() { return ServicesMasterRow.nameProperty; }
        protected getService() { return ServicesMasterService.baseUrl; }
        protected getDeletePermission() { return ServicesMasterRow.deletePermission; }
        protected getInsertPermission() { return ServicesMasterRow.insertPermission; }
        protected getUpdatePermission() { return ServicesMasterRow.updatePermission; }

        protected form = new ServicesMasterForm(this.idPrefix);

    }
}